module.exports = __webpack_public_path__ + "static/img/caterersmenu1EN.825aead.png";